// extracted by mini-css-extract-plugin
module.exports = {"logo":"onboarding_logo__qYGFK"};